export const WITHDRAW_LIMIT_FETCH = 'withdraw-limit/FETCH';
export const WITHDRAW_LIMIT_DATA  = 'withdraw-limit/DATA';
export const WITHDRAW_LIMIT_ERROR = 'withdraw-limit/ERROR';
